import type { Workspace } from '@carboncopyco/types';
import { ExpandDownIcon, TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { WorkspaceMenuItem } from './WorkspaceMenuItem';

interface WorkspaceSelectInputProps {
  open?: boolean;
  disabled?: boolean;
  workspace?: Partial<Workspace>;
}

export const WorkspaceSelectInput = ({
  open,
  disabled,
  workspace,
}: WorkspaceSelectInputProps) => {
  return (
    <div
      className={classNames(
        'relative w-full rounded-ds-md pl-2.5 pr-9 py-2 border-ds-natural-150 border',
        { 'bg-ds-natural-50 cursor-default': disabled }
      )}
    >
      {workspace ? (
        <WorkspaceMenuItem
          workspace={workspace}
          disabled={disabled}
        />
      ) : (
        <TextBase label="No workspace selected" />
      )}
      <ExpandDownIcon
        className="absolute right-2 top-0 h-full flex flex-col justify-center"
        rotate={open}
      />
    </div>
  );
};
